import type { SVGProps } from 'react'

interface PsychiatryIconProps extends SVGProps<SVGSVGElement> {}

export function PsychiatryIcon(props: PsychiatryIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M479.99-130q-12.76 0-21.37-8.63Q450-147.25 450-160v-287.46q-60.15 0-115.31-22.77-55.15-22.77-97.46-65.08-42.3-42.31-64.57-97.46-22.27-55.15-22.27-115.31v-24.61q0-15.2 10.28-25.49 10.28-10.28 25.49-10.28h24.61q58.85 0 113.96 22.96 55.12 22.96 97.42 65.27 31.39 31.39 51.5 70.12 20.12 38.73 28.81 82.27 6.92-12 15.42-22.74 8.5-10.73 18.97-21.19 42.18-42.24 97.48-65.23 55.3-23 115.28-23h24.62q15.2 0 25.48 10.29Q810-679.43 810-664.23v24.61q0 59.99-23 115.29-22.99 55.3-65.23 97.48-42.31 42.31-96.96 64.58Q570.15-340 510-340v180q0 12.75-8.63 21.37-8.63 8.63-21.38 8.63Zm-29.6-378.46q0-48-18.5-91.5t-52.5-77.5q-34-34-77.5-52.5t-91.5-18.5q0 48 18 92t52 78q34 34 78 52t92 18ZM510-400q48 0 91.5-18t77.5-52q34-34 52.5-78t18.5-92q-48 0-92 18.5T580-569q-34 34-52 77.5T510-400Zm0 0Zm-59.61-108.46Z" />
    </svg>
  )
}
